































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { maskMoney, timeout } from '@/utils/common'
import ResponseApi from '@/types/interfaces/FactoryResponse'
import _ from 'lodash'

@Component
export default class ComponentModalNovoItemAvulsoRepasse extends Vue {
  loadSaveNovoItemAvulso: boolean = false
  loadAnexo: boolean = false
  convenioSel: boolean = false
  searchProfissional: any = ''
  profissionalName: string = ''
  loadingProfissionalFilter: boolean = false

  fileName: string = ''
  $refs!: { formItemAvulso: any }

  formItemAvulsoRules: any = {
    valid: true,
    valorProcedimento: [(v: number) => !!v || 'Campo obrigatório'],
    quantidade: [(v: number) => !!v || 'Campo obrigatório'],
    transacaoFinanceira: [(v: string) => !!v || 'Campo obrigatório'],
    centroDeCusto: [(v: string) => !!v || 'Campo obrigatório'],
    profissionalExecutante: [(v: string) => !!v || 'Campo obrigatório'],
    funcaoProfissionalExecutante: [(v: string) => !!v || 'Campo obrigatório'],
    motivoInclusao: [(v: string) => !!v || 'Campo obrigatório'],
    convenioRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    planoRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    viaAcesso: [(v: string) => !!v || 'Campo obrigatório'],
    codigoProcedimento: [(v: string) => !!v || 'Campo obrigatório'],
    dataAtendimento: [(v: string) => (v.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(v)) || 'Formato de data inválido'],
  }

  profissionaisDebounced = _.debounce(param => this.getFinanceiroStore.getProfissionais(param), 500)

  get loadingSaveNovoItemAvulso() { return this.loadSaveNovoItemAvulso }
  set loadingSaveNovoItemAvulso(value: boolean) { this.loadSaveNovoItemAvulso = value }

  get loadingAnexo() { return this.loadAnexo }
  set loadingAnexo(value: boolean) { this.loadAnexo = value }

  get modalNovoItemAvulsoRepasse() { return this.getFinanceiroStore.modal.novoItemAvulsoRepasse }
  set modalNovoItemAvulsoRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'novoItemAvulsoRepasse', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get opcoesDeInclusaoDoItem() {
    const context = this.getFinanceiroStore.modalContext
    let itens: any = []

    if (context === 'cargaGeracao') {
      itens.push({ id: 4, descricao: 'Itens fixos - Carga planilha' })
      
      if (this.calculoAtivo) itens.unshift({ id: 3, descricao: 'Itens com cálculo - Carga planilha' })
      return itens;
    }

    itens.push({id: 1, descricao: 'Item fixo'})
    if (this.calculoAtivo) itens.push({  id: 2, descricao: 'Item com cálculo' })

    return itens
  }

  get getCodigoProcedimento() {
    return this.getFinanceiroStore.codigoProcedimento
  }

  get getTransacaoFinanceira() {
    return this.getFinanceiroStore.transacaoFinanceira
  }

  get getCentroDeCusto() {
    return this.getFinanceiroStore.centroDeCusto
  }

  get codigoProcedimento() {
    return this.getFinanceiroStore.codigoProcedimentoId
  }

  set codigoProcedimento(value: string) {
    this.getFinanceiroStore.setCodigoProcedimentoId(value)
  }

  get profissionaisExecutantes() {
    return this.getFinanceiroStore.profissionaisExecutantes
  }

  get funcoesProfissionalExecutante() {
    return this.getFinanceiroStore.funcoesProfissionalExecutante
  }

  get getConveniosRepasse() {
    return this.getFinanceiroStore.conveniosRepasse
  }

  get conveniosRepasseParaAutocomplete() {
    return this.getConveniosRepasse.map((convenio: any, index: number) => ({
      ...convenio,
      chaveAutocomplete: index,
    }))
  }

  get getPlanosRepasse() {
    return this.getFinanceiroStore.planosRepasse
  }

  get getViasAcesso() {
    return this.getFinanceiroStore.viasAcesso
  }

  get motivosInclusaoItemAvulso() {
    return this.getFinanceiroStore.motivosInclusaoItemAvulso
  }

  get profissionalExecutante() {
    return this.getFinanceiroStore.profissionalPontuacao
  }

  set profissionalExecutante(value: any) {
    this.getFinanceiroStore.setProfissionalPontuacao(value)
  }

  get funcaoProfissionalExecutante() {
    return this.getFinanceiroStore.funcaoProfissionalExecutante
  }

  set funcaoProfissionalExecutante(value: any) {
    this.getFinanceiroStore.setFuncaoProfissionalExecutante(value)
  }

  get convenioRepasse() {
    return this.getFinanceiroStore.convenioRepasse
  }

  set convenioRepasse(value: any) {
    this.getFinanceiroStore.setConvenioRepasse(value)
  }

  get planoRepasse() {
    return this.getFinanceiroStore.planoRepasse
  }

  set planoRepasse(value: any) {
    this.getFinanceiroStore.setPlanoRepasse(value)
  }

  get viaAcesso() {
    return this.getFinanceiroStore.viaAcesso
  }

  set viaAcesso(value: any) {
    this.getFinanceiroStore.setViaAcesso(value)
  }

  get motivoInclusao() {
    return this.getFinanceiroStore.motivoInclusao
  }

  set motivoInclusao(value: any) {
    this.getFinanceiroStore.setMotivoInclusao(value)
  }

  get observacao() {
    return this.getFinanceiroStore.observacao
  }

  set observacao(value: any) {
    this.getFinanceiroStore.setObservacao(value)
  }

  get urgente() {
    return this.getFinanceiroStore.urgente
  }

  set urgente(value: boolean) {
    this.getFinanceiroStore.setUrgente(value)
  }

  get numeroAtendimento() {
    return this.getFinanceiroStore.numeroAtendimento
  }

  set numeroAtendimento(value: any) {
    this.getFinanceiroStore.setNumeroAtendimento(value)
  }

  get dataAtendimento() {
    return this.getFinanceiroStore.dataAtendimento
  }

  set dataAtendimento(value: any) {
    this.getFinanceiroStore.setDataAtendimento(value)
  }

  get itemAvulsoRepasse() {
    return this.getFinanceiroStore.itemAvulsoRepasse
  }

  set itemAvulsoRepasse(value: any) {
    this.getFinanceiroStore.setItemAvulsoRepasse(value)
  }

  get centroDeCusto() {
    return this.getFinanceiroStore.centroDeCustoId
  }

  set centroDeCusto(value: string) {
    this.getFinanceiroStore.setCentroDeCustoId(value)
  }

  get transacaoFinanceira() {
    return this.getFinanceiroStore.transacaoFinanceiraId
  }

  set transacaoFinanceira(value: string) {
    this.getFinanceiroStore.setTransacaoFinanceiraId(value)
  }

  get valorProcedimento() {
    return this.getFinanceiroStore.valorProcedimento
  }

  set valorProcedimento(value: number) {
    this.getFinanceiroStore.setValorProcedimento(value)
  }

  get quantidade() {
    return this.getFinanceiroStore.quantidade
  }

  set quantidade(value: number) {
    this.getFinanceiroStore.setQuantidade(value)
  }

  get convenioSelecionado() {
    return this.convenioSel
  }

  set convenioSelecionado(value: boolean) {
    this.convenioSel = value
  }

  get nomePaciente() {
    return this.getFinanceiroStore.nomePaciente
  }

  set nomePaciente(value: string) {
    this.getFinanceiroStore.setNomePaciente(value)
  }

  get numeroConta() {
    return this.getFinanceiroStore.numeroConta
  }

  set numeroConta(value: string) {
    this.getFinanceiroStore.setNumeroConta(value)
  }

  get seqProcedimentoHis() {
    return this.getFinanceiroStore.seqProcedimentoHis
  }

  set seqProcedimentoHis(value: string) {
    this.getFinanceiroStore.setSeqProcedimentoHis(value)
  }

  get calculoAtivo() { return this.getFinanceiroStore.calculoAtivo }

  formatMoney(value) {
    return maskMoney(value)
  }

  async saveNovoItemAvulsoRepasse() {
    if (this.loadingSaveNovoItemAvulso) {
      return
    }

    if (!this.$refs.formItemAvulso.validate()) {
      return
    }

    if ((this.itemAvulsoRepasse === 3 || this.itemAvulsoRepasse === 4) && this.getFinanceiroStore.excelRepasse === null) {
      EventBus.$emit('setSnackbar', { show: true, text: 'É necessário inserir um arquivo para continuar!', icon: 'warning', color: '#C62828' })
      return
    }

    this.loadingSaveNovoItemAvulso = true
    let response: ResponseApi<any> | null = null

    try {
      switch (this.itemAvulsoRepasse) {
        case 2:
          response = await this.getFinanceiroStore.saveNovoItemAvulsoCalcularRepasse()
          break
        case 3:
          response = await this.getFinanceiroStore.saveInsercaoDeRegistrosEmLoteCalcularRepasse({
            formData: this.getFinanceiroStore.excelRepasse,
            context: this.getFinanceiroStore.modalContext,
          })
          break
        case 4:
          response = await this.getFinanceiroStore.saveItensFixosCargaPlanilha({
            formData: this.getFinanceiroStore.excelRepasse,
            context: this.getFinanceiroStore.modalContext,
          })
          break
        default:
          response = await this.getFinanceiroStore.saveNovoItemAvulsoRepasse()
          break
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao salvar!', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSaveNovoItemAvulso = false
    }

    if (response && response.success) {
      this.modalNovoItemAvulsoRepasse = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Novo item lançado com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
    } else if (response) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao salvar!', icon: 'warning', color: '#C62828' })
    }
  }

  async inputFile(newFile, oldFile) {
    this.loadingAnexo = true

    this.getFinanceiroStore.setExcelRepasse(newFile.file)
    this.fileName = newFile.name

    await timeout(2000)

    EventBus.$emit('setSnackbar', { show: true, text: 'Arquivo inserido com sucesso.', icon: 'done', color: '#2E7D32' })

    this.loadingAnexo = false
  }

  onConvenioRepasseChange(value: any) {
    if (value) {
      this.convenioSelecionado = true
      this.convenioRepasse = value.userId
      this.getFinanceiroStore.getPlanosRepasse()
    }
  }

   changeProfissionalExecutante(value: any) {
    if (value) {
      this.profissionalName = value.nome
      this.profissionalExecutante = value.userId
    } else {
      this.profissionalName = ''
    }
  }
  
  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      return
    }
    
    if(this.profissionalName === val){
      return
    }
    
    this.loadingProfissionalFilter = true
    
    await this.profissionaisDebounced(val)
  }

  @Watch('profissionaisExecutantes')
  onChangeProfissionaisExecutantes(value) {
    if(value) this.loadingProfissionalFilter = false
  }

  @Watch('modalNovoItemAvulsoRepasse')
  onModalNovoItemAvulsoRepasseChange(value: boolean) {
    if (!value) {
      this.$nextTick(() => {
        this.getFinanceiroStore.setProfissionalPontuacao('')
        this.getFinanceiroStore.setProfissionaisExecutantes([])
        this.fileName = ''
        this.getFinanceiroStore.setCodigoProcedimentoId('')
        this.getFinanceiroStore.setProfissionalPontuacao('')
        this.getFinanceiroStore.setObservacao('')
        this.getFinanceiroStore.setNumeroAtendimento('')
        this.getFinanceiroStore.setCentroDeCustoId('')
        this.getFinanceiroStore.setTransacaoFinanceiraId('')
        this.getFinanceiroStore.setItemAvulsoRepasse('')
        this.getFinanceiroStore.setConvenioRepasse('')
        this.getFinanceiroStore.setPlanoRepasse('')
        this.getFinanceiroStore.setViaAcesso('')
        this.getFinanceiroStore.setFuncaoProfissionalExecutante('')
        this.getFinanceiroStore.setMotivoInclusao('')
        this.getFinanceiroStore.setNomePaciente('')
        this.getFinanceiroStore.setNumeroConta('')
        this.getFinanceiroStore.setSeqProcedimentoHis('')
        this.getFinanceiroStore.setQuantidade(0)
        this.getFinanceiroStore.setValorProcedimento(0)
        this.$refs.formItemAvulso.resetValidation()
      })
    } else {
      if (this.getTransacaoFinanceira.length === 1) {
        this.transacaoFinanceira = this.getTransacaoFinanceira[0].id
      }

      if (this.getCentroDeCusto.length === 1) {
        this.centroDeCusto = this.getCentroDeCusto[0].id
      }

      if (this.motivosInclusaoItemAvulso.length === 1) {
        this.motivoInclusao = this.motivosInclusaoItemAvulso[0].id
      }
    }
  }
}
